import React from 'react';
import { useDocumentManagement, DocumentAdminLink } from '../features/legal/DocumentAdminAccess';
import { useLocation } from 'react-router-dom';
import ContactAdmin from './ContactAdmin';
import ContactForm from '../features/contact/ContactForm';
export default function Contact() {
  const managing = useDocumentManagement(),
    location = useLocation();
  return managing ? (
    <>
      <DocumentAdminLink editing />
      <ContactAdmin key={location.key} />
    </>
  ) : (
    <ContactForm key={location.key} />
  );
}
